<template>
  <div id="guestSelected" class="page">
    <h1>Das seid ihr</h1>
    <div id="foto_container">
    <div id="foto" v-bind:class="!guest.foto?'noFoto':''">
<!--         <img src="../assets/img/ben-2018.jpeg"> -->
      </div>
      <div id="kidsname">
          <p>{{guest.surname}}</p>
      </div>
    </div>  
<!--           <input type="file" @change="onFileChanged"> -->

    <div id="guestSelectedBox">
      <div class="columns">
        <div class="column">
          <h3>Hallo {{guest.surname}}</h3>
          <p>Kommst du zur Party?</p>
          <div class="actions">
            <p><a v-on:click="comes" v-bind:class="guest.comes === true ? 'button minWidth active' :'button minWidth' ">Ja</a> &nbsp; <a v-on:click="comesNot" v-bind:class="guest.comes === false ? 'button minWidth active':'button minWidth' ">Nein</a></p>
          </div>
          <div class="response">
            <p v-if="guest.comes === true">Toll, dass Du zur Party kommst :-)</p>
            <p v-if="guest.comes === false">Schade, dass Du nicht zur Party kommst.<br>Aber man kann ja nicht auf allen Parties tanzen ;-)</p>
          </div>
        </div>
        <div class="actions">
          <p v-if=" !$store.state.userfacts.gift && guest.comes === true"><a v-on:click="chooseGift" class="button minWidth">Geschenk auswählen</a></p>
        </div>
        <div class="thatsnotme">
          <p><a v-on:click="deselectKid" class="button minWidth">Ohhh... das sind wir gar nicht!</a></p>
        </div>
      </div>
    </div>  
  </div>
</template>
<script>
import {db} from '../service/firebase';  
import { find } from 'lodash'

export default {
  name: 'GuestSelected',
  components: {
    
  },
  firebase: {},
  data (){
    return {
      guest: {
        //wishes:[]
      },
      selectedFile: null
    }
  },
  computed: {
  },
  methods: {
  
  onFileChanged (event) {
    this.selectedFile = event.target.files[0]
  },
  onUpload() {
      const formData = new FormData()
      formData.append('myFile', this.selectedFile, this.selectedFile.name)
      axios.post('my-domain.com/file-upload', formData, {
        onUploadProgress: progressEvent => {
          console.log(progressEvent.loaded / progressEvent.total)
        }
      })
  },
  deselectKid(){
    console.log('de-select')

     this.guest.comes = null
      var updates = {};
      updates['parties/' + this.$store.state.currentParty +"/guests/" + this.$store.state.userfacts.kid + '/comes'] = null;
      var ref =  db.ref().update(updates)
      this.$store.state.userfacts.kid = null;
      this.$cookie.set('party', JSON.stringify(this.$store.state.userfacts), 30);  
      this.$router.push('/guests' )

  },
    chooseGift(){
      this.$router.push('/wishlist' )
    },
    comes(){
      this.guest.comes = true
      var updates = {};
      updates['parties/' + this.$store.state.currentParty +"/guests/" + this.$store.state.userfacts.kid + '/comes'] = true;
      var ref =  db.ref().update(updates)
      console.log(ref);
    },
    comesNot() {
      this.guest.comes = false
      var updates = {};
      updates['parties/' + this.$store.state.currentParty +"/guests/" + this.$store.state.userfacts.kid + '/comes'] = false;
      var ref =  db.ref().update(updates)
    } 
  },
  mounted() {
    //console.log( this.guest );
   //this.$bindAsObject('guest', db.ref('parties/' + this.$store.state.currentParty +"/guests/" + this.$store.state.userfacts.kid  ), null, function() { /* console.log(self.guest) */ } );
    //console.log( this.$store.state.currentParty )
  },
  created (){
  //console.log( 'parties/' + this.$store.state.currentParty +"/guests/" + this.$store.state.userfacts.kid )
   this.$bindAsObject('guest', db.ref('parties/' + this.$store.state.currentParty +"/guests/" + this.$store.state.userfacts.kid  ), null, function() { /* console.log(self.guest) */ } );
  },
}
</script>
<style>
  .button.minWidth { min-width: 5em; }
  .button.active { border-color: #9cd708; }
  .response p { margin: 0; }
  .noFoto { background: #efefef url(../assets/img/kigebu-icon-cam-white.svg) center center no-repeat; background-size: 2.83333em; } 
</style>